import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a wardrobe (1.8 x 0.6 x 2.2): oak body, two plaster door
// fronts with long matte-black handles, thin plinth.
const OAK = "#c8975a";
const PLASTER = "#e8e4dc";
const BLACK = "#2e2e30";

export const wardrobe = defineModel({
  id: "wardrobe",
  batchId: "modern",
  name: "Wardrobe",
  tags: ["modern", "interior", "furniture", "bedroom", "storage"],
  summary: "A two-door oak wardrobe with long black handles.",
  tiles: { w: 2, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // thin plinth
      { geometry: new THREE.BoxGeometry(1.7, 0.08, 0.52), color: BLACK, position: [0, 0.04, 0] },
      // body
      { geometry: new THREE.BoxGeometry(1.8, 2.12, 0.6), color: OAK, position: [0, 1.14, 0] },
      // two door fronts
      { geometry: new THREE.BoxGeometry(0.85, 2.0, 0.03), color: PLASTER, position: [-0.445, 1.14, 0.315] },
      { geometry: new THREE.BoxGeometry(0.85, 2.0, 0.03), color: PLASTER, position: [0.445, 1.14, 0.315] },
      // long vertical handles beside the centre gap
      { geometry: new THREE.BoxGeometry(0.025, 0.6, 0.025), color: BLACK, position: [-0.08, 1.2, 0.345] },
      { geometry: new THREE.BoxGeometry(0.025, 0.6, 0.025), color: BLACK, position: [0.08, 1.2, 0.345] },
    ];
  },
  animations: [],
});
